/**
 * @Author: Dabson Ferreira
 * @Date:   2023-11-24 11:58:05
 */


export const LocalStorageVariables = {
    PageToken: 'token',
    InactivityTimer: 'inactivity_timer'
};

